









































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { IDocumentPage } from '@lib-shared/types/document-page';
import type { IRecipient } from '@lib-shared/types/Recipient';
import type { IField } from '@lib-shared/fields/types/field';
import type { IUser } from '@signing-page/users/types/user';
import Field from '@signing-page/fields/components/Field.vue';

@Component({
  components: {
    Field,
  },
})
export default class DocumentContentPage extends Vue {
  @Prop() page!: IDocumentPage;
  @Prop() pageWidth: number;
  @Prop() recipient: IRecipient;
  @Prop() allRecipients: IRecipient[];
  @Prop() sender: IUser;
  @Prop() focusedRequiredId?: string;
  @Prop() hideFields!: boolean;
  @Prop() isPreview!: boolean;
  @Prop() requiredStepsLeft!: boolean;
  @Prop() isSigned!: boolean;
  @Prop() initials: string;
  @Prop() verifiedInitialFieldIds: string[];

  imageIsLoaded = false;
  imageError = false;

  get fields(): IField[] {
    return (this.page && this.page.fields) || [];
  }

  get disableFields(): boolean {
    return this.isPreview;
  }

  get documentPageElementId(): string {
    return this.page ? `document-content-page-${this.page.id}` : 'document-content-page';
  }

  get skeletonHeight(): number {
    return this.page ? (this.pageWidth / this.page.pageWidth) * this.page.pageHeight : 900;
  }

  get thumbUrl(): string {
    return this.page ? this.page.thumbUrl : '';
  }

  get showFields(): boolean {
    return this.imageIsLoaded && !this.imageError && !this.hideFields;
  }

  imageDescription(pageNumber: number) {
    return this.$t('document-page', { 'page-number': pageNumber });
  }

  handleClickLinkField(id: string) {
    this.$emit('clickLinkField', id);
  }

  handleClickInitialsField(id: string) {
    this.$emit('clickInitialsField', id);
  }

  handleClickSignField() {
    this.$emit('clickSignField');
  }

  handleLoaded() {
    this.imageIsLoaded = true;
    this.imageError = false;
    this.$emit('loaded');
  }

  handleImgError() {
    this.imageError = true;
  }

  handleUpdateField({ fieldId, value }: { fieldId: string; value: string }) {
    this.$emit('updateField', { fieldId, value });
  }
}
